import React from 'react';
import './MarqueeBanner.css';

const ITEM = (
  <>
    <span className="marquee-banner__brand">PREMSI</span>
    <span className="marquee-banner__sep"> • </span>
    <span className="marquee-banner__tagline">Get paid for your personality</span>
    <span className="marquee-banner__sep"> • </span>
  </>
);

function MarqueeBanner() {
  const repeatCount = 15;
  const items = Array.from({ length: repeatCount }, (_, i) => (
    <span key={i} className="marquee-banner__item">
      {ITEM}
    </span>
  ));

  return (
    <div className="marquee-banner" aria-hidden="true">
      <div className="marquee-banner__track">
        <div className="marquee-banner__content">{items}</div>
        <div className="marquee-banner__content" aria-hidden="true">
          {items}
        </div>
      </div>
    </div>
  );
}

export default MarqueeBanner;
